import type { AccessBlocker } from '@/access/types';

type RawAccessRemediation = {
  action: string;
  context?: Record<string, unknown> | null;
};

type RawAccessBlocker = {
  reasonCode?: string;
  reason_code?: string;
  message?: string;
  remediation?: RawAccessRemediation | Record<string, unknown>;
};

export function normalizeAccessBlocker(blocker: RawAccessBlocker): AccessBlocker {
  const remediation = blocker.remediation as RawAccessRemediation | undefined;

  return {
    reasonCode: String(blocker.reasonCode ?? blocker.reason_code ?? ''),
    message: String(blocker.message ?? ''),
    remediation: {
      action: String(remediation?.action ?? ''),
      context: (remediation?.context ?? {}) as Record<string, unknown>,
    },
  };
}

/** GraphQL authorization errors expose blockers with snake_case keys. List order is ranking. */
export function normalizeAccessBlockersFromExtensions(blockers: Array<Record<string, unknown>> | undefined): AccessBlocker[] {
  if (!blockers?.length) {
    return [];
  }

  return blockers.map((blocker) => normalizeAccessBlocker(blocker as RawAccessBlocker));
}
